import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";
import { categories } from "@/mocks/categories";

const stats = [
  { value: "8.6万+", label: "全库漫画作品" },
  { value: "3000+", label: "每日更新章节" },
  { value: "40+", label: "细分类目覆盖" },
  { value: "5000万+", label: "累计阅读人次" },
];

const featured = [
  { id: 1, title: "焚天剑尊 · 重生归来篇", tag: "本季强推", cover: comics[0].cover, desc: "叶无双一剑开天门，焚天神剑正式觉醒。" },
  { id: 2, title: "万古圣主 · 诸天降临篇", tag: "爆款连载", cover: comics[8].cover, desc: "圣主归来，万界臣服，全新篇章震撼开启。" },
  { id: 3, title: "御剑问长生 · 仙路争锋", tag: "口碑佳作", cover: comics[6].cover, desc: "少年御剑问天，仙途尽头谁主沉浮。" },
  { id: 4, title: "星海远征军 · 深空之秘", tag: "科幻新潮", cover: comics[4].cover, desc: "远征军深入未知星域，真相正在浮现。" },
];

const testimonials = [
  { name: "夜风残", role: "热血玄幻爱好者", text: "天堂漫画的全库真的太全了，找冷门老漫画再也不用几个网站来回切，全站分类清晰，一搜就能定位。" },
  { name: "奶茶三分甜", role: "恋爱甜宠党", text: "更新特别快，追的连载每天都能看到最新话。收藏夹功能也顺手，追番体验一级棒。" },
  { name: "老侦探迷", role: "推理悬疑读者", text: "完结作品书库非常完整，评分和标签都靠谱，按我的口味推荐的基本都没踩雷。" },
];

const faqs = [
  { q: "天堂漫画全库的漫画会持续更新吗？", a: "会的。天堂漫画完整书库持续更新，热门连载作品每日同步最新章节，冷门完结作品也会持续补全，确保全站漫画海量资源保持新鲜完整。" },
  { q: "如何快速找到自己想看的漫画？", a: "你可以使用顶部搜索直接输入作品名或作者，也可以进入全站分类页，按热血玄幻、恋爱校园等 40+ 类目逐层筛选，轻松定位目标作品。" },
  { q: "在手机上能正常阅读吗？", a: "完全没问题。天堂漫画采用响应式设计，手机、平板、电脑都能流畅阅读，页面会自适应屏幕，随时随地追漫画。" },
  { q: "收藏的作品去哪里查看？", a: "登录账号后，浏览作品时点击「加入书架」即可收藏，在个人书架中可以集中管理所有追更作品，方便随时续读。" },
];

export default function Home() {
  const [keyword, setKeyword] = useState("");
  const hotList = useMemo(() => comics.slice().sort((a, b) => b.rating - a.rating), []);
  const newList = useMemo(() => comics.slice().sort((a, b) => Number(a.id) - Number(b.id)).slice(6, 14), []);

  return (
    <>
      {/* Hero */}
      <section className="relative flex min-h-[560px] items-center overflow-hidden md:h-[640px]">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20illustration%20of%20a%20grand%20fantasy%20city%20under%20a%20vast%20starry%20night%20sky%2C%20a%20young%20heroic%20silhouette%20standing%20on%20a%20rooftop%20holding%20a%20glowing%20red%20sword%2C%20dynamic%20action%20composition%2C%20rich%20crimson%20red%20and%20warm%20gold%20color%20palette%20with%20deep%20ink%20black%20shadows%2C%20dramatic%20cinematic%20lighting%2C%20energetic%20speed%20lines%20and%20comic%20panel%20effects%2C%20epic%20storytelling%20mood%2C%20detailed%20digital%20painting%2C%20vivid%20and%20immersive%20manga%20cover%20style%20artwork%20for%20a%20comics%20reading%20website%20hero%20banner&width=1600&height=900&seq=home-hero-mh&orientation=landscape"
            alt="天堂漫画全库 · 海量漫画资源视觉插画"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-background-50"></div>
        </div>
        <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:px-6">
          <span className="font-label inline-flex items-center gap-2 rounded-full border border-accent-400/60 bg-accent-500/15 px-4 py-1.5 text-sm text-accent-200 backdrop-blur">
            <i className="ri-fire-fill"></i>
            天堂漫画 · 全站漫画总目录
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            全库完整书库，<span className="text-accent-300">海量资源全收录</span>
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
            无论热门连载还是冷门完结，都能在总目录中快速定位。一站找全，省去多站切换的麻烦，让每一份热爱都不被辜负。
          </p>
          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            <Link
              to="/categories"
              className="w-full whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-base font-semibold text-background-50 shadow-ink transition-colors hover:bg-primary-600 sm:w-auto"
            >
              开始浏览全库
            </Link>
            <Link
              to="/ranking"
              className="w-full whitespace-nowrap rounded-full border border-background-100/40 bg-background-50/10 px-8 py-3.5 text-base font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              查看人气排行
            </Link>
          </div>
          <div className="mx-auto mt-8 flex max-w-xl items-center gap-2 rounded-full border border-background-100/30 bg-background-50/95 px-4 py-2.5 text-foreground-700 backdrop-blur">
            <i className="ri-search-line text-lg text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入漫画名 / 作者，一站找全"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-500"
              aria-label="搜索漫画"
            />
            <Link
              to={`/categories?q=${encodeURIComponent(keyword.trim() || "热血")}`}
              className="whitespace-nowrap rounded-full bg-secondary-500 px-5 py-1.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
            >
              搜索
            </Link>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="-mt-10 grid grid-cols-2 gap-3 rounded-2xl border border-background-200 bg-background-100 p-6 shadow-ink-sm lg:grid-cols-4 md:p-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Popular ongoing */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <span className="flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-fire-fill"></i> 热门连载
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">追更最多的正在连载</h2>
          </div>
          <Link to="/ranking" className="flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700">
            查看全部排行 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 lg:grid-cols-6 md:gap-6">
          {hotList.slice(0, 6).map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </section>

      {/* Categories */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="text-center">
            <span className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-layout-grid-fill"></i> 全库分类
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">40+ 类目，一站找全你想看的</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">天堂漫画全库完整书库覆盖多元题材，无论热血还是治愈，都能精准命中。</p>
          </div>
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {categories.map((c, i) => (
              <Link
                key={c.id}
                to={`/categories?type=${c.slug}`}
                className={`group rounded-2xl p-5 transition-all hover:-translate-y-1 hover:shadow-ink-sm ${
                  i % 3 === 0 ? "bg-primary-500" : i % 3 === 1 ? "bg-secondary-500" : "bg-accent-500"
                }`}
              >
                <span className={`flex h-11 w-11 items-center justify-center rounded-xl text-2xl ${
                  i % 3 === 0 ? "bg-primary-700" : i % 3 === 1 ? "bg-secondary-700" : "bg-accent-600"
                } text-background-50`}>
                  <i className={c.icon}></i>
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold text-background-50">{c.name}</h3>
                <p className="mt-1 text-sm text-background-100/90 line-clamp-2">{c.description}</p>
                <p className="mt-3 flex items-center gap-1 text-xs text-background-50/80">
                  {c.count} 部作品 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Featured new */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <span className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-sparkling-fill"></i> 新作专题
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">本季不容错过的专题企划</h2>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((f) => (
            <article key={f.id} className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-ink-sm">
              <div className="relative h-48 overflow-hidden">
                <img src={f.cover} alt={`${f.title} 专题封面`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">{f.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">{f.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 line-clamp-2">{f.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm text-secondary-700">
                  进入专题 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
        <div className="mt-8 text-center">
          <Link to="/featured" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600">
            浏览全部新作专题 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      {/* New releases grid */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
            <div>
              <span className="flex items-center gap-2 text-sm font-medium text-primary-600">
                <i className="ri-time-line"></i> 最新收录
              </span>
              <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">全库完整书库 · 每日更新</h2>
            </div>
            <Link to="/categories" className="flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700">
              浏览更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 lg:grid-cols-4 md:gap-6">
            {newList.map((c) => (
              <ComicCard key={c.id} comic={c} />
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <span className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-chat-quote-fill"></i> 读者口碑
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">千万读者都在天堂漫画找漫画</h2>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-100 p-6">
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">「{t.text}」</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-base font-bold text-primary-700">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="mx-auto max-w-4xl px-4 pb-14 md:px-6 md:pb-20">
        <div className="text-center">
          <span className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-question-line"></i> 常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">关于天堂漫画，你可能想问</h2>
        </div>
        <div className="mt-8 space-y-3">
          {faqs.map((f) => (
            <details key={f.q} className="group rounded-xl border border-background-200 bg-background-100 p-5">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3 font-medium text-foreground-950 [&::-webkit-details-marker]:hidden">
                <span>{f.q}</span>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-transform group-open:rotate-180">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
            </details>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="mx-auto max-w-7xl px-4 pb-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-primary-600 px-6 py-12 text-center md:px-12 md:py-16">
          <div className="absolute -right-8 -top-8 h-40 w-40 rounded-full bg-primary-500/60 blur-2xl"></div>
          <div className="absolute -bottom-10 -left-6 h-40 w-40 rounded-full bg-accent-500/40 blur-2xl"></div>
          <div className="relative">
            <h2 className="font-heading text-2xl font-black text-background-50 md:text-3xl">今天想看点什么？来全库找一找</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-background-100 md:text-base">
              海量资源全收录，全库完整书库持续更新，把想看的漫画，一次找齐。
            </p>
            <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link to="/categories" className="w-full whitespace-nowrap rounded-full bg-background-50 px-8 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 sm:w-auto">
                进入全站分类
              </Link>
              <Link to="/ranking" className="w-full whitespace-nowrap rounded-full border border-background-50/50 px-8 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto">
                看看人气排行
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </>
  );
}